import { redirect } from "react-router";
import Root from "./root";
import Landing from "./routes/landing";
import LegalLayout from "./routes/legal/layout";
import Privacy from "./routes/legal/privacy";
import Terms from "./routes/legal/terms";

// Hardcoded — env vars through Vite's SSR build are fiddly. If this needs
// to change per environment, edit this constant.
const PRICING_API_URL = "https://app.titanskip.com/api/pricing";

console.log(`[DEBUG] routes.jsx LOADED, PRICING_API_URL=${PRICING_API_URL}`);

// Safe defaults — used if the pricing API is unreachable so the page never
// breaks. Matches the live API shape; metered + plans are intentionally
// excluded from the public surface.
const PRICING_FALLBACK = {
  creditTiers: [
    { key: "tier1", min: 1000, max: 4999, label: "1,000 – 4,999", rate: 0.05 },
    { key: "tier2", min: 5000, max: 9999, label: "5,000 – 9,999", rate: 0.04 },
    { key: "tier3", min: 10000, max: 99999, label: "10,000 – 99,999", rate: 0.03 },
    { key: "tier4", min: 100000, max: null, label: "100,000+", rate: 0.02 },
  ],
  traceRates: { normal: 1, enhanced: 2, llc: 3 },
};

async function pricingLoader() {
  console.log(`[pricing] LOADER CALLED → fetching ${PRICING_API_URL}`);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3000);
  try {
    const res = await fetch(PRICING_API_URL, { signal: controller.signal });
    console.log(`[pricing] fetch returned status ${res.status}`);
    if (!res.ok) throw new Error(`pricing API ${res.status} ${res.statusText}`);
    const data = await res.json();
    // Strip internal-only fields before they leave the server — metered
    // pricing and prebuilt plans are not publicly advertised.
    return {
      creditTiers: data.creditTiers ?? PRICING_FALLBACK.creditTiers,
      traceRates: data.traceRates ?? PRICING_FALLBACK.traceRates,
    };
  } catch (err) {
    // Always surface why we fell back, otherwise debugging "the page shows
    // stale pricing" turns into a guessing game.
    console.error(
      `[pricing] fetch ${PRICING_API_URL} failed — using fallback:`,
      err?.message ?? err
    );
    return PRICING_FALLBACK;
  } finally {
    clearTimeout(timeout);
  }
}

export const routes = [
  {
    path: "/",
    Component: Root,
    children: [
      {
        index: true,
        Component: Landing,
        loader: pricingLoader,
      },
      {
        path: "legal",
        Component: LegalLayout,
        children: [
          { index: true, loader: () => redirect("/legal/terms") },
          { path: "terms", Component: Terms },
          { path: "privacy", Component: Privacy },
        ],
      },
    ],
  },
];
